import { reactive } from 'vue';
import auth from '@/auth.js';

const state = reactive({});

function resolveUrl(url) {
	if (url && url.startsWith('/uploads/')) {
		return process.env.BASE_URL + url.slice(1);
	}
	return url;
}

function unresolveUrl(url) {
	const prefix = process.env.BASE_URL + 'uploads/';
	if (url && url.startsWith(prefix)) {
		return '/' + url.slice(process.env.BASE_URL.length);
	}
	return url;
}

function resolveItem(item) {
	return { ...item, image: { ...item.image, src: (item.image.src || []).map(resolveUrl) } };
}

async function fetchItems(collection) {
	try {
		const res = await fetch(`${process.env.BASE_URL}api/items/${collection}`);
		if (!res.ok) return;
		const data = await res.json();
		state[collection] = data.map(resolveItem);
	} catch {
		// backend not reachable - keep local state empty
	}
}

function getItems(collection) {
	return state[collection] || [];
}

function unresolvePayload(payload) {
	const out = { ...payload };
	if (Array.isArray(out.existingImages)) {
		out.existingImages = out.existingImages.map(unresolveUrl);
	}
	return out;
}

async function addItem(collection, payload) {
	try {
		const res = await fetch(`${process.env.BASE_URL}api/items/${collection}`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', ...auth.authHeaders() },
			body: JSON.stringify(unresolvePayload(payload)),
		});
		const data = await res.json().catch(() => ({}));
		if (!res.ok) {
			return { ok: false, error: data.error || 'Request failed' };
		}
		const item = resolveItem(data);
		if (!state[collection]) state[collection] = [];
		state[collection].push(item);
		return { ok: true, item };
	} catch {
		return { ok: false, error: 'Network error' };
	}
}

async function updateItem(collection, id, payload) {
	try {
		const res = await fetch(`${process.env.BASE_URL}api/items/${collection}/${id}`, {
			method: 'PUT',
			headers: { 'Content-Type': 'application/json', ...auth.authHeaders() },
			body: JSON.stringify(unresolvePayload(payload)),
		});
		const data = await res.json().catch(() => ({}));
		if (!res.ok) {
			return { ok: false, error: data.error || 'Request failed' };
		}
		const item = resolveItem(data);
		const list = state[collection] || [];
		const index = list.findIndex((it) => it.id === id);
		if (index !== -1) list[index] = item;
		return { ok: true, item };
	} catch {
		return { ok: false, error: 'Network error' };
	}
}

async function deleteItem(collection, id) {
	try {
		const res = await fetch(`${process.env.BASE_URL}api/items/${collection}/${id}`, {
			method: 'DELETE',
			headers: auth.authHeaders(),
		});
		if (!res.ok) {
			const data = await res.json().catch(() => ({}));
			return { ok: false, error: data.error || 'Request failed' };
		}
		state[collection] = (state[collection] || []).filter((it) => it.id !== id);
		return { ok: true };
	} catch {
		return { ok: false, error: 'Network error' };
	}
}

fetchItems('games');
fetchItems('goodies');
fetchItems('demos');
fetchItems('virtualskipper');
fetchItems('gallery');

export default { state, getItems, addItem, updateItem, deleteItem };
